import { ReactElement, ReactNode } from 'react'
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch'
import { LoadingButton, LoadingButtonProps } from '@mui/lab'

interface Props extends LoadingButtonProps {
  children?: ReactNode
}

const ImportButton = ({
  children = 'Importieren',
  variant = 'contained',
  ...props
}: Props): ReactElement => (
  <LoadingButton variant={variant} startIcon={<RocketLaunchIcon />} {...props}>
    {children}
  </LoadingButton>
)

export default ImportButton
